



































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import { FormState } from '@/components/prine/enums/FormState';
import ConfirmModal from '@/components/prine/ConfirmModal.vue';

import type { Project } from '@/models/project';

import type { Experience } from '@/models/experience';
import { experienceWebservice } from '@/webservices/experience';

import ProjectChooser from '@/components/utils/ProjectChooser.vue';
import { hasAnyPermission, hasPermission } from '@/helpers/auth/permissionHelpers';
import { PERMISSIONS } from '@/helpers/auth/permissions';
import { transferExperiencePermissions } from '@/helpers/auth/commonPermissions';

@Component({
    name: 'StoreUpdateExperience',
    computed: {
        PERMISSIONS() {
            return PERMISSIONS;
        },
    },
    methods: { hasAnyPermission, hasPermission },
    components: {
        ConfirmModal,
        ProjectChooser,
    },
})
export default class StoreUpdateExperience extends Vue {
    public FormState = FormState;

    private experiences = Array<Experience>();

    private tableSettings = {
        isStriped: true,
        isHoverable: true,
        isPaginated: false,
        defaultSortDirection: 'desc',
    };

    // Data
    private disabled: boolean = false;
    private errorMsg: string = '';
    private serverErrorMsg: string = '';
    private state: FormState = FormState.New;

    private experience: Experience = {} as Experience;

    private loading = {
        data: false,
        color: '#fdc05d',
        size: '40px',
    };

    @Getter('project/selectedProject') private selectedProject: Project;

    @Watch('selectedProject')
    private onsSelectedProjectValueChange() {
        this.loadData();
    }
    // Mounted is called initially
    private mounted() {
        this.loadData();
        this.$store.commit('utils/setCurrentRoutePath', '/experiences');
    }

    get canTransfer(): boolean {
        return hasAnyPermission(transferExperiencePermissions);
    }

    get showActions(): boolean {
        return this.canTransfer || this.canDelete || this.canEdit;
    }

    get canDelete(): boolean {
        return hasPermission(PERMISSIONS.APPEX_EXPERIENCE_DELETE);
    }

    get canEdit(): boolean {
        return hasPermission(PERMISSIONS.APPEX_EXPERIENCE_EDIT);
    }

    private loadData() {
        const self = this;
        this.experience = {} as Experience;
        this.errorMsg = '';
        this.state = FormState.New;

        experienceWebservice.loadByProject(this.selectedProject).then((response) => {
            self.experiences = response.data;
        });
    }

    private updateExperience(experience: Experience) {
        this.state = FormState.Update;
        this.experience = JSON.parse(JSON.stringify(experience));
    }

    private save() {
        this.disabled = true;
        const self = this;
        if (!this.validate()) {
            this.disabled = false;
            return 0;
        }

        if (this.state === FormState.New) {
            this.experience.project = self.selectedProject;

            experienceWebservice
                .store(this.experience)
                .then((response) => {
                    self.loadData();
                })
                .catch((error) => {
                    console.error(error);
                });
        } else if (this.state === FormState.Update) {
            experienceWebservice
                .update(this.experience)
                .then((response) => {
                    self.loadData();
                })
                .catch((error) => {
                    console.error(error);
                    if (error.response.status === 404) {
                        this.serverErrorMsg = error.response.data;
                    }
                });
        }
    }

    private deleteExperience(experience: Experience) {
        experienceWebservice
            .remove(experience)
            .then((response) => {
                this.$buefy.snackbar.open(this.$t('toastMessages.delete.experience').toString());
                this.loadData();
            })
            .catch((error) => {
                console.error(error);
            });
    }

    private validate() {
        if (!this.experience.problem || this.experience.problem === '') {
            this.errorMsg = 'problem';
            return 0;
        } else {
            return true;
        }
    }
}
